import { User as UserModel } from '@web-portal/domains/shared/domain-models';

export class User implements UserModel {
  email = '';
  firstName = '';
  lastName = '';
  initials = '';
}
